#import "../fragments/booking-fragment.graphql"

query GetBookings($input: BookingsInput!) {
    bookings(input: $input) {
        totalCount
        pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
        }
        edges {
            node {
                ...BookingFragment
            }
        }
    }
}
